import "./GarcomLogin.css";
import React from "react";
import { FaUser, FaLock, FaConciergeBell, FaStore } from "react-icons/fa";

const GarcomLogin = ({
  garcons,
  garcomSelecionado,
  setGarcomSelecionado,
  setorSelecionado,
  setSetorSelecionado,
  senha,
  setSenha,
  handleLogin,
  erro,
  intervalosPorSetor
}) => (
  <div className="login-container d-flex align-items-center justify-content-center vh-100">
    <div className="card shadow-lg p-4" style={{ maxWidth: "400px", width: "100%" }}>
      <h2 className="text-center mb-4 fw-bold">Login do Garçom</h2>
      {erro && <div className="alert alert-danger text-center">{erro}</div>}

      {/* Usuário */}
      <div className="mb-3">
        <label className="form-label fw-semibold">
          <FaUser className="me-2" /> Usuário
        </label>
        <select
          className="form-select rounded-pill"
          value={garcomSelecionado}
          onChange={(e) => setGarcomSelecionado(e.target.value)}
        >
          <option value="">Selecione...</option>
          {garcons.map((garcom) => (
            <option key={garcom.id} value={garcom.id}>
              {garcom.nome}
            </option>
          ))}
        </select>
      </div>

      {/* Setor */}
      <div className="mb-3">
        <label className="form-label fw-semibold">
          <FaStore className="me-2" /> Setor
        </label>
        <select
          className="form-select rounded-pill"
          value={setorSelecionado}
          onChange={(e) => setSetorSelecionado(e.target.value)}
        >
          <option value="">Selecione o Setor...</option>
          {Object.keys(intervalosPorSetor).map((setor) => (
            <option key={setor} value={setor}>
              {setor}
            </option>
          ))}
        </select>
      </div>

      {/* Senha */}
      <div className="mb-4">
        <label className="form-label fw-semibold">
          <FaLock className="me-2" /> Senha
        </label>
        <input
          type="password"
          className="form-control rounded-pill"
          placeholder="Digite sua senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
      </div>

      {/* Botão de Login */}
      <button
        className="btn btn-primary rounded-pill w-100 fw-bold py-2"
        onClick={handleLogin}
      >
        <FaConciergeBell className="me-2" /> Entrar
      </button>
    </div>
  </div>
);

export default GarcomLogin;
